import React, { useEffect, useState } from 'react'
import { useCardCombinations } from './CUSTOM_RULES_CONTENT'
import { COEFS } from './interface'
import CombinationsContainer from './CombinationsContainer'
import BetButtons from './BetButtons'
import { otherCoefs } from './CONTENT'
export default function CustomRules(coefs: COEFS) {
  const [ante, setAnte] = useState<string[]>([''])
  const [anteCombinations] = useCardCombinations(ante)
  const [othersCombinations] = useCardCombinations(otherCoefs)

  useEffect(() => {
    coefs.coefs && setAnte(coefs.coefs)
  }, [coefs.coefs])
  
  return (
    <>
      <BetButtons />
      <h3>Ante payoff</h3>
      <CombinationsContainer coefs={anteCombinations} />
      <h3>Raise, Turn, River payoff</h3>
      <CombinationsContainer coefs={othersCombinations} />
    </>
  )
}
